import { createContext, useContext } from "react";
import type { KeyContext } from "../shortcuts";

/** What a page tells the shell about the key that fired an action. */
export interface ActionCtx { arg?: number; event?: KeyboardEvent }
export type ActionMap = Record<string, (c?: ActionCtx) => void | Promise<void>>;

export interface ShellApi {
  /** A page registers the actions it implements (menu items, shortcuts), and how to describe its state to the key resolver. */
  register(actions: ActionMap, probe?: () => Partial<KeyContext>): () => void;
  /** Ticks the page wants shown on checkable menu items, by action id. */
  setChecked(checked: Record<string, boolean>): void;
  run(action: string, ctx?: ActionCtx): void;
}

export const ShellCtx = createContext<ShellApi | null>(null);
export function useShell(): ShellApi {
  const s = useContext(ShellCtx);
  if (!s) throw new Error("useShell outside Shell");
  return s;
}
